import type { ProjectId, AssetId } from 'owa-timestream-types';
import getAsset from './getAsset';

export default function getLastKnownBounds(projectId: ProjectId, assetId: AssetId) {
    const asset = getAsset(projectId, assetId);
    return asset
        ? {
              x: asset.bounds.x,
              y: asset.bounds.y,
              width: asset.bounds.lastKnownWidth || asset.bounds.width,
              height: asset.bounds.lastKnownHeight || asset.bounds.height,
          }
        : undefined;
}
